export default __webpack_public_path__ + "assets/front/scss/error.a8e03af2fa01747a79f2e6ae858dae50.css";